import { VossVersionStatus as VossVersionStatusImp, VossVersionStatusText } from "../../Constants/VOSS/vossVersionStatus";
import helpers from "../../Utils/helpers";
import Card from "../Card/Card";
import { Dropdown } from "../FormComponents/Dropdown";

export function VossVersionStatus({ status, versions, onSelectVersion, selectedVersion }) {

    const renderStatus = () => {
        let label = VossVersionStatusText[status];
        let labelClass;

        switch (status) {
            case VossVersionStatusImp.Draft:
                labelClass = "text-primary";
                break;
            case VossVersionStatusImp.Staged:
                labelClass = "text-secondary";
                break;
            case VossVersionStatusImp.Published:
                labelClass = "text-success";
                break;
            case VossVersionStatusImp.Archived:
                labelClass = "text-warning";
                break;
            case VossVersionStatusImp.Discarded:
                labelClass = "text-error";
                break;
        }

        return <div className="bg-default rounded-8 col-12 py-12">
            <div className="text-center">
                <p className="mb-8">Version status:</p>
                <h1 className={`${labelClass} mb-0`}>{label}</h1>
            </div>
        </div>
    }

    const prepareDropdownOptions = () => {
        if (!versions) return [];
        return versions.versions.map(version => {
            return {
                name: VossVersionStatusText[version.status] + ' - ' + helpers.formatDateAndTime(version.created),
                id: version.versionId
            };
        });
    }

    let options = prepareDropdownOptions();

    return <Card>
        <Card.Content>
            <div className="d-flex flex-column align-items-center gap-24">
                {renderStatus()}
                <div className="w-100">
                    <Dropdown value={selectedVersion} label={'Version history'} options={options} onChange={(value) => onSelectVersion(value)}/>
                </div>
            </div>
        </Card.Content>
    </Card>
}